<template>
  <validation-provider
    :rules="rules"
    :name="name"
    :vid="vid"
    ref="validator"
    v-slot="{ errors }"
  >
    <div
      class="control"
      :class="{
        'has-icons': iconLeft || iconRight,
        'has-icons-left': iconLeft,
        'has-icons-right': iconRight,
        'is-danger': errors.length > 0
      }"
    >
      <flat-pickr
        ref="input"
        :config="config"
        class="input"
        :placeholder="placeholder"
        v-model="currentValue"
      />
      <icon :name="iconLeft" class="is-left" />
      <icon :name="iconRight" class="is-right" />
      <p class="help is-danger">{{ errors[0] }}</p>
    </div>
  </validation-provider>
</template>

<script>
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Polish } from "flatpickr/dist/l10n/pl.js";
import { Icon } from "%helpers";

export default {
  name: "control-date-time-picker",

  components: {
    FlatPickr,
    Icon
  },

  props: {
    type: {
      type: String,
      default: "text"
    },

    vid: String,
    name: String,
    rules: [Object, String],

    iconLeft: String,
    iconRight: String,

    value: undefined,
    placeholder: String,

    altFormat: {
      type: String,
      default: "M j, Y"
    },
    dateFormat: {
      type: String,
      default: "Y-m-d"
    },
    time: Boolean,
    noCalendar: Boolean,
    dates: {
      type: [Array, Function],
      default: () => []
    }
  },

  data() {
    return {
      currentValue: null,
      config: {
        altFormat: this.altFormat,
        altInput: true,
        dateFormat: this.dateFormat,
        locale: Polish,
        enableTime: this.time,
        noCalendar: this.noCalendar,
        enable: this.dates
      }
    };
  },

  mounted() {
    this.currentValue = this.value;
  },

  methods: {
    setErrors(errors) {
      this.$refs.validator.setErrors(errors);
    },

    focus() {
      this.$refs.input.focus();
    },

    blur() {
      this.$refs.input.blur();
    }
  },

  watch: {
    value(val) {
      this.currentValue = val;
    },

    currentValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.is-danger::v-deep * {
  border-color: $danger;
}
</style>
